import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-become-creator-stats"
}
const _hoisted_2 = {
  class: "gfu-grid _tac",
  role: "list"
}
const _hoisted_3 = { class: "gfu-become-creator-value" }
const _hoisted_4 = { class: "_ttu gfu-bt--caption" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return ($options.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass($options.layoutClass)
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.stats, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.title,
                class: _normalizeClass(['gfu-grid__cell gfu-1of2 gfu-1of4--m gfu-content-divider', $options.dividerClass]),
                role: "listitem"
              }, [
                _createElementVNode("h5", _hoisted_3, _toDisplayString(item.value), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(item.title) + " ", 1 /* TEXT */),
                  (item.tooltip)
                    ? (_openBlock(), _createBlock(_component_tooltip, {
                        key: 0,
                        text: item.tooltip
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "circle-info",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["text"]))
                    : _createCommentVNode("v-if", true)
                ])
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */)
      ]))
    : _createCommentVNode("v-if", true)
}